import { TYPE_IDS } from '../../../constants/apiV4TypeIds';
import { Destination } from './types';

export const DESTINATION_CONNECTOR_ID = {
  [Destination.Anaplan]: TYPE_IDS.AnaplanConfiguration,
  [Destination.Database]: TYPE_IDS.AzureSqlServerConfiguration,
  [Destination.NextWorld]: TYPE_IDS.NextWorldConfiguration,
  [Destination.Salesforce]: TYPE_IDS.SalesforceConfiguration,
};
